import React from "react";
import aboutimage from "../assets/aboutus/bn.jpg";
import WhoWeAre from "../component/WhoWeAre";
import Impact from "../component/CoreFocus";
import EventsAndGetInvolved from "../component/ImpactEvents";
import HeroSection from "../component/HeroSection";
import ServicesPrograms from "../component/ServicesPrograms";
import CoreObjectives from "./extpage/CoreObjectives";

export const Home = () => {
  return (
    <>
      <div>
        <HeroSection />
        <div className="featured">
          <div className="featured-grid">
            <div className="feature-card">
              <div className="feature-icon">⚖️</div>
              <h3 style={{ color: "#c72800ff" }}>Professional Excellence</h3>
              <p>
                Advancing legal practice standards and professional conduct
                among advocates
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🎓</div>
              <h3 style={{ color: "#c72800ff" }}>Mentorship &amp; Training</h3>
              <p>
                Comprehensive programs for skill development and career
                advancement
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🤝</div>
              <h3 style={{ color: "#c72800ff" }}>Community Building</h3>
              <p>
                Networking and collaborative opportunities for legal
                professionals
              </p>
            </div>
          </div>
        </div>
        <CoreObjectives />
        <WhoWeAre />
        <EventsAndGetInvolved />
        {/* About Section */}
        <section className="about" id="about">
          <div className="about-container">
            <div className="about-img">
              <img src={aboutimage} alt="Indian Advocate Professional" />
            </div>
            <div>
              <h2 style={{ color: "#c72800ff", fontWeight: "700" }}>
                About ICSAJ
              </h2>
              <p>
                The{" "}
                <strong>
                  International Council of Sanatan Advocacy & Justice (ICSAJ)
                </strong>
                is a legal and advocacy-focused institution dedicated to
                promoting excellence in legal practice, ethical advocacy, and
                justice administration across India. Inspired by the timeless
                principles of Sanatan Dharm, the Council draws upon foundational
                values such as <strong>Dharma</strong> (righteousness),
                <strong> Nyaya</strong> (justice), <strong>Satya</strong>{" "}
                (truth), and
                <strong> Karuṇā</strong> (compassion). to inform and strengthen
                contemporary legal systems and advocacy practices
              </p>
              <p>
                ICSAJ provides a collaborative platform for advocates, legal
                professionals, scholars, and students to enhance professional
                skills, engage in meaningful legal discourse, and contribute to
                the development of a just, fair, and accessible justice delivery
                system. The Council seeks to integrate ethical wisdom with
                modern constitutional and legal frameworks, fostering advocacy
                that is principled, responsible, and socially conscious. ICSAJ
                remains firmly aligned with the values of constitutionalism and
                secularism. The Council envisions a legal culture where justice
                is not merely procedural, but substantive and morally grounded,
                ensuring dignity, fairness, and the rule of law for all.
              </p>
            </div>
          </div>
        </section>
        {/* Services Section */}
        <ServicesPrograms />
        {/* Contact Section */}
        {/* <section className="contact" id="contact">
          <div className="contact-container">
            <h2 style={{ color: "#f35c04ff" }}>Get In Touch</h2>
            <form className="contact-form" onsubmit="handleSubmit(event)">
              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <input type="text" id="name" name="name" required />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input type="email" id="email" name="email" required />
              </div>
              <div className="form-group">
                <label htmlFor="mobile">mobile Number</label>
                <input type="tel" id="mobile" name="mobile" required />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  required
                  defaultValue={""}
                />
              </div>
              <button
                type="submit"
                className="btn-primary"
                style={{ width: "100%" }}
              >
                Send Message
              </button>
            </form>
          </div>
        </section> */}
        {/* counters for  */}
        <Impact />
      </div>
    </>
  );
};
